module.exports = __webpack_public_path__ + "img/triangles_2.d9102cb0.png";